import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetAllowedDomainsRPC } from "./getAllowedDomainsRPC";

export class GetAllowedDomainsRPCClientImpl extends GetAllowedDomainsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetAllowedDomainsRPC.Request): Promise<LeoRPCResult<GetAllowedDomainsRPC.Response, GetAllowedDomainsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetAllowedDomains",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetAllowedDomainsRPC.ResponseDTO,
      GetAllowedDomainsRPC.Errors.ErrorsDTO,
      GetAllowedDomainsRPC.Response,
      GetAllowedDomainsRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetAllowedDomains",
      GetAllowedDomainsRPC.Response.fromDTO,
      GetAllowedDomainsRPC.Errors.fromDTO
    );
  }
}
